import { useSelector } from "react-redux";
import { RootState } from "../../store";

const MetadataTab = ({ slide }) => {
    const { storyline } = useSelector((state: RootState) => state.storyline);

    return <div className="table-container">
        <table className="table bordered no-header key-value">
            <tbody>
                <tr>
                    <td className="heading-cell">
                        Storyline
                    </td>
                    <td>
                        {storyline.name}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Template
                    </td>
                    <td>
                        {slide.templateName}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Chapter
                    </td>
                    <td>
                        {slide.chapterName}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Page
                    </td>
                    <td>
                        {slide.pageName}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Paragraph
                    </td>
                    <td>
                        {slide.name}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>;
};

export default MetadataTab;